<template>
	<div class="content-box">
		<div class="operator">
			<div class="operator-col">
				<warehouse-input v-model="filterWarehouse"></warehouse-input>
			</div>
			<div class="operator-col">
				<hispickup v-model="filterHisDate"></hispickup>
			</div>
			<div class="operator-col">
				<el-input
					size="mini"
					v-model="filterTableSearch"
					placeholder="商品名"
					suffix-icon="el-icon-search"
					clearable
				></el-input>
			</div>
		</div>
		<curd-table
			ref="listTable"
			:data-model="editorDataModel"
			:list-ops="listOps"
			:has-op-slot="true"
			:fields="tableFields"
			:has-delete="false"
			list-url="inventory/list_tx/recv"
			:search-filter="filterTableSearch"
			:has-expand-show="true"
		>
			<template slot="expandShow" slot-scope="scope">
				<div>
					<h5>备注</h5>
					<p>{{scope.row.desc}}</p>
				</div>
				<table class="table table-bordered">
					<tr v-for="tx_item in scope.row.tx_items" :key="tx_item._id">
						<td v-for="(key,index) in itemTableFields" :key="index">
							<field-show
								:field-info="dataModels.Tx_item[key.name]"
								:value="tx_item[key.name]"
								:field-key="key"
							></field-show>
						</td>
					</tr>
				</table>
			</template>
			<template slot="listOp" slot-scope="scope">
				<el-button size="mini" type="text" @click="goTxInfo(scope.row._id)">详情</el-button>
				<el-button
					size="mini"
					type="text"
					@click="goRecvTx(scope.row._id)"
					v-if="scope.row.status.index==20 "
				>收到退货</el-button>
				<!-- <el-button
					size="mini"
					type="text"
					@click="goRejectTx(scope.row._id)"
					v-if="scope.row.status.index==20 "
				>打回</el-button>-->
			</template>
		</curd-table>
		<editor
			:show.sync="editorVisibleRecv"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="sendFields"
			handler-url="inventory/do_tx_op/recv/"
			@change="refreshTable('listTable')"
		></editor>
	</div>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";

import LoadDM from "@/mixins/LoadDM.js";
import TxOp from "@/mixinsApp/TxOp.js";

export default {
	mixins: [CurdPage, Filters, FilterWarehouse, TxOp, LoadDM],

	data() {
		return {
			loadings: {
				main: false,
			},
			editorDataModel: "Transaction",
			dataModelNames: ["Transaction", "Tx_item"],
			listOps: [
				{
					name: "info",
					show_name: "详情",
					handler: "goinfo",
				},
			],
			tableFields: [
				{
					name: "show_id",
				},
				{
					name: "warehouse",
					sortable: "custom",
				},
				{
					name: "customer",
					sortable: "custom",
					width: "90px",
				},
				{
					name: "express_type",
					render: info => {
						return "[" + info.express_type.name + "] " + info.address.name;
					},
				},
				{
					name: "order",
					params: {
						link: "Order-Info",
					},
				},
				{
					name: "order_show_id",
				},
				{
					name: "name",
					sortable: "custom",
				},

				{
					name: "total_price",
					sortable: "custom",
				},
				{
					name: "tx_at",
					sortable: "custom",
				},
			],
		};
	},

	methods: {},
	watch: {
		$route() {
			this.refreshTable("listTable");
		},
	},
};
</script>
<style lang="scss" scoped>
</style>